export default __webpack_public_path__ + "95f32ecf5f339e8e2e1a68df06f1bd14.png";